module.exports = __webpack_public_path__ + "img/icon-ig-lg.4e188f1b.png";